import { render, staticRenderFns } from "./OrderStatusPicker.vue?vue&type=template&id=220b2bd4"
import script from "./OrderStatusPicker.vue?vue&type=script&lang=js"
export * from "./OrderStatusPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports